import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailTemplateComponent } from './email-template/email-template.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { GetSafeHTMLEmailPipe } from '../pipes/getSafeHTMLEmail.pipe';
import { SkeletonModule } from 'primeng/skeleton';
import { Popover } from "primeng/popover";
import { Select } from "primeng/select";


@NgModule({
  declarations: [
    EmailTemplateComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GetSafeHTMLEmailPipe,
    SkeletonModule,
    Popover,
    Select
],
  exports: [
    EmailTemplateComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class EmailModule { }
